<template>
  <div class="contentPopup">
    <van-popup v-model="isPromoteRuleShow"
               :closeable="false"
               :round="true"
               :close-on-click-overlay="false"
               overlay
               class="promotePopup">
      <div class="block">
        <div class="title-popup">{{activityInfo.activityName}}活动规则</div>
        <div class="content">
          <h2>芒果M-CLUB 金秋{{activityInfo.activityName}}榜单，个人收入排名前20名、且满足领取条件的情况下，即可获得现金奖励。</h2>
          1、收入统计时间：2022年{{activityInfo.startTime}}17:00-{{activityInfo.endTime}}23:59<br />
          2、具体奖金及领取条件：<br />
          第一名：奖金8000元，个人收入不低于7680元<br />
          第二名：奖金5000元，个人收入不低于6400元<br />
          第三名：奖金3000元，个人收入不低于4160元<br />
          第四名到第六名：奖金1200元，个人收入不低于1920<br />
          第七名到第十名：奖金700元，个人收入不低于1920<br />
          第十一名到第二十名：奖金450元，个人收入不低于1920元<br />
          3、奖金发放规则：<br />
          1）奖金到账：活动于2022年{{activityInfo.endTime}}23:59结束后将进行一日公示，公示后的第一个工作日按照最终排名，以佣金形式发放排行榜对应奖金至大使的M-CLUB账户，请至【我的】奖励明细查看；<br />
          2）若大使存在收入相同的情况，则以最后一笔订单的时间为准，订单生成时间较前的大使，则排名在前，单个用户不可重复领奖。<br />
          3）根据最终个人收入所满足的领取条件，自动匹配符合奖金，以实际收入的高低进行排名；<br />
          4）如无人满足发放条件，则当前排名奖金空缺。例如：大使A实际排名第1，个人收入6000，不符合达标条件，则第一名奖金空缺，大使A可得第二名5000元奖励。<br />
          5）每个排名对应的奖金，仅可领取1次，按照最终收入顺延。<br />
          4、活动参与条件：所有芒果M-CLUB注册用户（M-CLUB账号封停用户除外）均可参与本次活动<br />
          5、其他说明<br />
          1）相关销售数据以芒果M-CLUB后台数据为准，若有疑问，请及时联系客服。<br />
          2）活动期间，如用户存在违反法律、法规或违反包括但不限于芒果M-CLUB及其他活动合作平台方规则，包括但不限于作弊、采用不正当技术手段获得商品等行为，芒果M-CLUB将有权取消用户的成绩，撤销违规交易，收回商品或权益。<br />
          3）活动期间如出现不可抗力或情势变更的情况（包括但不限于重大灾害事件、活动受政府机关指令需要停止举办或调整、活动遭受严重网络攻击或因系统故障需要暂停举办的），M-CLUB可依相关法律法规的规定主张免责。<br />
          4）若您对本次活动规则有任何疑问，芒果M-CLUB将在法律允许的范围内对本活动规则给予必要的说明和解释。请您及时阅读，如有疑问，欢迎随时与我们的客服联系，客服入口，关注【芒果推广大使】公众号-点击【我要赚钱】-【我的】-【联系客服】。<br />
          6.未成年人特殊约定<br />
          1）若您为未成年人，应在监护人监护、指导下阅读本活动规则。<br />
          2）监护人应指导未成年人上网应该注意的安全问题，防患于未然。若监护人同意未成年人使用本活动消费项目，必须以监护人名义申请消费，并对未成年人使用消费项目进行正确引导、监督。未成年人使用消费项目，以及行使和履行本协议项下的权利和义务即视为已获得了监护人的认可。<br />
          3）芒果M-CLUB提醒未成年人在使用网络虚拟服务时，要善于网上学习，认清网络世界与现实世界的区别，避免沉迷于网络，影响日常的学习生活。<br />
        </div>
      </div>
      <div class="iconClose"
           @click="handleClose">
        <img src="https://fulu-tuike.oss-cn-hangzhou.aliyuncs.com/picture/da95a2d54baa45149f27cfa45619775b.png"
             alt="">
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    isPromoteRuleShow: {
      type: Boolean
    },
    activityInfo: {
      type: Object
    }
  },
  data() {
    return {}
  },
  created() {},
  mounted() {
    console.log(this.activityInfo, '88888888')
  },
  methods: {
    handleClose() {
      // this.isPromoteRuleShow = false
      this.$emit('closeRulePopup')
    }
  }
}
</script>
<style lang="less" scoped>
.promotePopup {
  background-color: transparent;
  height: 11.18rem;

  .block {
    position: relative;
    padding-top: 0.001rem;
    width: 8.4rem;
    height: 9.4rem;
    background: #ffffff;
    border-radius: 0.21rem;
    box-sizing: border-box;

    .title-popup {
      margin: 0.4rem 0 0;
      text-align: center;
      font-size: 0.45rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 700;
      color: #333333;
      line-height: 0.64rem;
    }

    .content::-webkit-scrollbar {
      display: none;
    }

    .content {
      margin: 0.27rem 0.32rem 1.24rem;
      padding: 0.27rem;
      height: 6.85rem;
      background: #f9f6f6;
      border-radius: 0.19rem;
      box-sizing: border-box;
      overflow-x: hidden;
      overflow-y: scroll;
    }
  }

  .iconClose {
    position: absolute;
    top: 9.8rem;
    left: 50%;
    width: 1.28rem;
    height: 1.28rem;
    margin-left: -0.64rem;

    & > img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>